import { createUrlMatcher } from "../url-matcher/factory.js";
import { UrlMatcher, UrlPatternType } from "../url-matcher/types.js";

export enum Platform {
	DEFAULT = 0,
	ALEKS = 1,
	MCGRAW_HILL = 2,
	PEARSON = 3,
	CENGAGE = 4,
	WILEY = 5,
	MY_OPEN_MATH = 6,
	WW_NORTON = 7,
	U_CERTIFY = 8,
	WEBWORK = 9,
	MACMILLAN = 10,
	LABYRINTH = 11,
	ZYBOOKS = 12,
	VHL = 13,
	ATOMIC = 14,
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const PLATFORM_MATCHERS: Partial<Record<Platform, UrlMatcher<any>>> = {
	[Platform.MCGRAW_HILL]: createUrlMatcher({
		type: UrlPatternType.COMPOSITE,
		urlPatterns: [
			{
				type: UrlPatternType.WILDCARD,
				pattern: "https://connect.router.integration.prod.mheducation.com/*/heclrReturn",
			},
			{
				type: UrlPatternType.WILDCARD,
				pattern: "https://connect.router.integration.prod.mheducation.com/*/coversheet",
			},
			{
				type: UrlPatternType.WILDCARD,
				pattern: "https://sso.router.integration.prod.mheducation.com/*/coversheet*",
			},
			{
				type: UrlPatternType.WILDCARD,
				pattern: "https://lms.mheducation.com/*/launch*",
			},
			{
				type: UrlPatternType.WILDCARD,
				pattern: "https://*.simnetonline.com/*/assignments/*",
			},
			{ type: UrlPatternType.DOMAIN, domain: "mhcampus.com" },
		],
	}),
	[Platform.PEARSON]: createUrlMatcher({
		type: UrlPatternType.COMPOSITE,
		urlPatterns: [
			{ type: UrlPatternType.DOMAIN, domain: "pearson.com" },
			{ type: UrlPatternType.DOMAIN, domain: "mypearson.com" },
		],
	}),
	[Platform.ALEKS]: createUrlMatcher({
		type: UrlPatternType.COMPOSITE,
		urlPatterns: [
			{ type: UrlPatternType.WILDCARD, pattern: "https://*.aleks.com/*#home" },
			{ type: UrlPatternType.WILDCARD, pattern: "https://*.aleks.com/*#assignment*" },
			{ type: UrlPatternType.DOMAIN, domain: "aleks.com" },
		],
	}),
	[Platform.WILEY]: createUrlMatcher({
		type: UrlPatternType.COMPOSITE,
		urlPatterns: [
			{
				type: UrlPatternType.REGEX,
				regex: "https?://([\\w.-]+\\.)?wiley\\.com/.*assessment-player.*",
			},
		],
	}),
	[Platform.CENGAGE]: createUrlMatcher({
		type: UrlPatternType.COMPOSITE,
		urlPatterns: [
			{
				type: UrlPatternType.REGEX,
				regex: "https?://([\\w.-]+\\.)?cengage\\.com/.*static.*",
			},
			{ type: UrlPatternType.DOMAIN, domain: "cengage.com" },
		],
	}),
	[Platform.MY_OPEN_MATH]: createUrlMatcher({
		type: UrlPatternType.COMPOSITE,
		urlPatterns: [
			{
				type: UrlPatternType.REGEX,
				regex: "https?://([\\w.-]+\\.)?myopenmath\\.com/assess2/.*",
			},
			{ type: UrlPatternType.DOMAIN, domain: "myopenmath.com" },
		],
	}),
	[Platform.WW_NORTON]: createUrlMatcher({
		type: UrlPatternType.COMPOSITE,
		urlPatterns: [{ type: UrlPatternType.DOMAIN, domain: "wwnorton.com" }],
	}),
	[Platform.U_CERTIFY]: createUrlMatcher({
		type: UrlPatternType.COMPOSITE,
		urlPatterns: [{ type: UrlPatternType.DOMAIN, domain: "ucertify.com" }],
	}),
	[Platform.WEBWORK]: createUrlMatcher({
		type: UrlPatternType.COMPOSITE,
		urlPatterns: [
			{
				type: UrlPatternType.WILDCARD,
				pattern: "https://webwork.*.edu/webwork2/*",
			},
			{
				type: UrlPatternType.WILDCARD,
				pattern: "https://webwork-prod-app.*/webwork2/*",
			},
		],
	}),
	[Platform.MACMILLAN]: createUrlMatcher({
		type: UrlPatternType.COMPOSITE,
		urlPatterns: [{ type: UrlPatternType.DOMAIN, domain: "macmillanlearning.com" }],
	}),
	[Platform.LABYRINTH]: createUrlMatcher({
		type: UrlPatternType.COMPOSITE,
		urlPatterns: [{ type: UrlPatternType.DOMAIN, domain: "labyrinthelab.com" }],
	}),
	[Platform.ZYBOOKS]: createUrlMatcher({
		type: UrlPatternType.COMPOSITE,
		urlPatterns: [{ type: UrlPatternType.HOSTNAME, hostname: "exams-learn.zybooks.com" }],
	}),
	[Platform.ATOMIC]: createUrlMatcher({
		type: UrlPatternType.COMPOSITE,
		urlPatterns: [
			{ type: UrlPatternType.HOSTNAME, hostname: "atomicjoltapps.com" },
			{ type: UrlPatternType.HOSTNAME, hostname: "atomicjolt.com" },
		],
	}),
	[Platform.VHL]: createUrlMatcher({
		type: UrlPatternType.COMPOSITE,
		urlPatterns: [{ type: UrlPatternType.DOMAIN, domain: "vhlcentral.com" }],
	}),
};

export function getPlatformIdFromUrl(url: string | null): number | null {
	if (url === null) return null;
	for (const [platformKey, matcher] of Object.entries(PLATFORM_MATCHERS)) {
		const platform = Number(platformKey);
		if (matcher.match(url)) {
			return platform;
		}
	}

	return null;
}
